export * from './admin-columns';
export * from './api-google';
export * from './card';
export * from './certificate-layout';
export * from './client-columns';
export * from './cookie';
export * from './coupon';
export * from './course';
export * from './default';
export * from './designation-element';
export * from './email-preferences';
export * from './objects';
export * from './options';
export * from './organization-columns';
export * from './path';
export * from './pusher';
export * from './queue';
export * from './regex';
export * from './rest-api';
export * from './seat';
export * from './shipping';
export * from './sow-orders';
export * from './training-product';
export * from './url';

export const DEFAULT_DATE_FORMAT = 'MM-DD-YYYY';
export const DEFAULT_DATE_TIME_FORMAT = 'MM-DD-YYYY HH:mm:ss';
export const DEFAULT_DATE_MONTH_NAME_TIME_FORMAT = 'MMM D, YYYY h:mmA';
export const DEFAULT_DATE_MONTH_NAME_FORMAT = 'MMM D, YYYY';
export const DEFAULT_DATE_SHORTEN_FORMAT = 'MM-DD-YYYY h:mm A';
export const DEFAULT_DATE_SHORTEN_MONTH_NAME_FORMAT = 'MMM D, YYYY';
export const DEFAULT_DATE_PICKER_FORMAT = 'MM/DD/YYYY';
export const DEFAULT_DATE_INPUT_FORMAT = 'MM/dd/yyyy';
export const DEFAULT_DATE_TIME_INPUT_FORMAT = 'MM/dd/yyyy h:mm aa';
export const DEFAULT_DATE_MONTH_NAME_TIME_NUMBER_FORMAT = 'MM/DD/YYYY h:mm A';
export const TIME_ZONE_EST = 'America/New_York';

export const DEFAULT_TIME_ZONE = {
     UK: 'Europe/London',
     EST: 'America/New_York',
     VN: 'Asia/Ho_Chi_Minh',
};

export const CONSENT_FORM = 'consentForm';
export const EDUCATION_FORM = 'educationForm';
export const PRACTICE_FORM = 'practiceForm';
export const BOOK_VERIFICATION_FORM = 'bookVerificationForm';
export const SUICIDE_SPECIFIC_FORM = 'suicideSpecificFormik';

export const EDITOR_OPTIONS = ['inline', 'blockType', 'list', 'textAlign', 'colorPicker', 'link'];
export const EDITOR_OPTIONS_TWO = ['inline'];

export const LOCAL_CART = 'cart';
export const LOCAL_CONTENT_MANAGEMENT = 'content-management';
export const LOCAL_COUPON = 'coupon';
export const LOCAL_COUPON_VOUCHERS = 'coupon-vouchers';
export const LOCAL_DIRECT_PATH = 'direct-path';
export const LOCAL_LICENSEE = 'licensee';
export const LOCAL_LOGIN_AS_UNDER_USER = 'login-as-under-user';
export const LOCAL_LOGIN_AS_SESSION = 'login-as-session';
export const LOCAL_ORG_USER = 'org-user';
export const LOCAL_PAYMENT_METHOD = 'payment-method';
export const LOCAL_SHOW_PROFESSIONAL_PAGE = 'show-professional-page';
export const LOCAL_TIME_ZONE = 'timezone';
export const LOCAL_TYPE_OF_PURCHASE = 'type-of-purchase';
export const LOCAL_USER_ROLE = 'user-role';

export const SESSION_FORCE_LOGGED_USER_EXIT = 'force-logged-user-exit';
export const SESSION_TOTAL_ORDER = 'total-order';
export const SESSION_PREV_PATHNAME = 'prev-pathname';
export const SESSION_RECEIVED_VOUCHER = 'received-voucher';

export const FALSY_VALUES = ['', 'undefined', 'null', 'false', '0', false, undefined, null, NaN];
export const FALSY_STRING_VALUES = ['', 'undefined', 'null', 'false', '0'];

export const ENV_OBJ = {
     prod: 'cams-care.com',
     development: 'cams-care.com',
     staging: 'hostedstaging.com',
};

export const EVENT_MODE = {
     BLUR: 'blur',
     CANCEL: 'cancel',
     CHANGE: 'change',
     CLOSE: 'close',
     KEYDOWN: 'keydown',
     KEYUP: 'keyup',
     REMOVE: 'remove',
};

export const GENERAL_MODE = {
     READ: 'read',
     CREATE: 'create',
     UPDATE: 'update',
     DELETE: 'delete',
};

export const START_MODE = {
     K8S: 'k8s',
     DOCKER_COMPOSE: 'docker-compose',
};

export const STATUS = {
     ENABLE: 'enable',
     DISABLED: 'disabled',
};

export const GENERIC_STATUS = {
     ACTIVATED: 'activated',
     INACTIVATED: 'inactivated',
};

export const GENERIC_STATUS_ARR = [
     { id: 'activated', name: 'Activated' },
     { id: 'inactivated', name: 'Inactivated' },
];

export const STATUS_HISTORICAL = {
     CANCEL: 'cancel',
     IN_PROGRESS: 'in-progress',
     COMPLETED: 'completed',
};

export const STATUS_HISTORICAL_LABEL = {
     GOOD: 'Good',
     ISSUES: 'Issues',
     CANCEL: 'Cancel',
};

export const IS_PRIVATE = {
     YES: 'yes',
     NO: 'no',
};

export const BADGE_STATUS = {
     ENABLE: 'enable',
     DISABLED: 'disabled',
     SHIPPED: 'SHIPPED',
     ERROR: 'ERROR',
};

export const CART_TYPES = {
     INDIVIDUAL: 'individual',
     ORGANIZATION: 'organization',
     INVISIBLE: 'invisible',
     BOTH: 'both',
};

export const TAB_SELECT_PURCHASE = {
     PERSONAL_TRAINING: 'personal-training',
     TEAM_TRAINING: 'team-training',
};

export const EXTENSION_ALLOW = {
     DOC_EXCEL: /\.(pdf|doc|docx|xls|xlsx|xlsm)$/,
     MEDIA: /\.(jpg|jpeg|png|jfif|svg|webp|gif|pdf|mp4)$/,
     IMAGE_ONLY: /\.(jpg|jpeg|png|jfif|svg|webp|gif)$/,
     IMAGE_AND_VIDEO: /\.(jpg|jpeg|png|jfif|svg|webp|gif|mp4)$/,
     ALL_FILE: /\.(pdf|doc|docx|csv|xls|xlsx|xlsm|jpg|jpeg|png|jfif|svg|webp|gif)$/,
};

export const ASSIGN_TYPE = {
     ALL: 'ALL',
     ASSIGN: 'ASSIGN',
     NOT_ASSIGN: 'NOT_ASSIGN',
};

export const COURSE_STATUS = {
     NO_ACCESS: 'no access',
     ACCESSED: 'accessed',
     NOT_STARTED: 'not-started',
     STARTED: 'started',
     IN_PROGRESS: 'in-progress',
     COMPLETED: 'completed',
     FILLED: 'filled',
};

export const COURSE_STATUS_CLIENT = {
     NOT_STARTED: 'Not Started',
     PENDING: 'Pending',
     COMPLETED: 'Completed',
};

export const ACTIVITY_STATUS = {
     PENDING_PAYMENT: 'PENDING_PAYMENT',
     CANCELED: 'CANCELED',
     PROCESSING: 'PROCESSING',
     COMPLETED: 'COMPLETED',
     REFUNDED: 'REFUNDED',
     WAITING: 'WAITING',
};

export const ORDER_ITEM_STATUS = {
     PENDING_PAYMENT: 'PENDING_PAYMENT',
     CANCELED: 'CANCELED',
     PROCESSING: 'PROCESSING',
     COMPLETED: 'COMPLETED',
     REFUNDED: 'REFUNDED',
     WAITING_TO_REFUND: 'WAITING_TO_REFUND',
};

export const ORDER_STATUS = {
     FAILED: 'Failed',
     AWAITING_PAYMENT: 'AwaitingPayment',
     CANCELED: 'Canceled',
     COMPLETED: 'Completed',
     VOID: 'Void',
     UNCOLLECTIBLE: 'Uncollectible',
     OPEN: 'Open',
     CLOSE: 'Close',
};

export const SEAT_STATUS = {
     OPEN: 'open',
     RESERVED: 'reserved',
     NOT_STARTED: 'not-started',
     FILLED: 'filled',
     ACCESSED: 'accessed',
     IN_PROGRESS: 'in-progress',
     COMPLETED: 'completed',
     EXPIRED: 'expired',
     ACCESS_REMOVED: 'access-removed',
};

export const EVENT_CREDIT_STATUS = {
     OPEN: 'open',
     RESERVED: 'reserved',
     NO_SELECTED: 'NO_SELECTED',
     SELECTED: 'SELECTED',
     ACCESS_REMOVED: 'access-removed',
};

export const BUNDLE_SEAT_STATUS = {
     OPEN: 'open',
     RESERVED: 'reserved',
     ACCEPTED: 'accepted',
};

export const TEST_STATUS = {
     NOT_STARTED: 'not-started',
     FAILED: 'failed',
     PASSED: 'passed',
};

export const USER_ROLES = {
     SYSTEM_ADMIN: 'system-admin',
     SYSTEM_ADMIN_LOWER: 'admin',
     SUBSCRIBER: 'subscriber',
};

export const USER_ROLE_LABEL = {
     'system-admin': 'System Admin',
     admin: 'Admin',
     subscriber: 'Subscriber',
};

export const SUBSCRIBER_USER_ROLES = {
     INDIVIDUAL: 'individual',
     ORGANIZATION: 'organization',
};

export const ORG_USER_ROLES = {
     OWNER: 'owner',
     MANAGER: 'manager',
     USER: 'user',
     TRAINEE: 'trainee',
};

export const QUESTION = {
     YES: 'yes',
     NO: 'no',
};

export const TYPE_QUESTION = {
     SINGLE_CHOICE: 'single-choice',
     MULTIPLE_CHOICE: 'multiple-choice',
     ASK_FOR_ANSWER: 'ask-for-answer',
     DROPDOWN_LIST_CHOICE: 'dropdown-list-choice',
     LIKERT_SCALE: 'likert-scale',
};

export const POPUP_TYPE = {
     ADDED_CART: 'added-cart',
     ASSIGN_MULTIPLE_USERS: 'assign-multiple-users',
     CHANGE_OWNER: 'change-owner',
     CREATE_ORG: 'create-org',
     ERROR_ADD_CART: 'error-add-cart',
     ERROR_DUPLICATE_PRODUCT_ADD_CART: 'error-duplicate-product-add-cart',
     PRODUCT_AVAILABLE_IN_CART: 'product-available-in-cart',
     REMOVE_CART: 'remove-cart',
     REMOVE_SEAT: 'remove-seat',
     SELECT_OR_CREATE_ORG: 'select-or-create-org',
     SELECT_ORG: 'select-org',
     SEND_CODE: 'send-code',
     SWITCH_PURCHASE: 'switch-purchase',
     UNFINISHED: 'unfinished',
     VERIFY_CODE: 'verify-code',
     WARNING_RELATED: 'warning-related',
     WARNING_REMAINING_SEATS: 'warning-remaining-seats',
     REDIS_DETAILS: 'redis-details',
     SELLING_GROUP_FILTER_CHOOSE: 'selling-group-filter-choose',
};

export const COURSE_DIRECT_PATH = 'courseDirectPath';

export const CHOOSE_YOUR_EVENT_DATE = 'choose-your-event-date';

export const MY_TRAINING = 'my-training';

export const FETCH_ADDRESS_URL = 'https://ipwho.is/';

export const NO_DATA = '[No Data]';

export const NOT_AVAILABLE = 'N/A';

export const CUSTOM_DATE_DEFAULT_NAME = 'Custom Date';

export const COURSE_STATUS_LABEL = {
     NO_ACCESS: 'no access',
     ACCESSED: 'accessed',
     NOT_STARTED: 'not started',
     PENDING: 'pending',
     STARTED: 'started',
     IN_PROGRESS: 'in progress',
     COMPLETED: 'completed',
};

export const LINK_STATUS = {
     AVAILABLE: 'AVAILABLE',
     ASSIGNED: 'ASSIGNED',
};

export const LINK_STATUS_LABEL = {
     AVAILABLE: 'Available',
     ASSIGNED: 'Assigned',
};

export const NOTICE_TYPE = {
     SYSTEM: 'system',
     CE_CREDIT: 'cecredit',
     SEAT: 'seat',
     COURSE: 'course',
     LESSONS: 'lesson',
     SURVEY: 'survey',
     TEST: 'test',
     PURCHASE_CE: 'purchase-ce',
     PURCHASE_EVENT: 'purchase-event',
     SELECT_EVENT: 'select-event',
     SELECT_EVENT_CREDIT: 'select-event-credit',
     BUNDLE_SEAT: 'bundle-seat',
     VOUCHER: 'voucher',
};

export const BROWSER_CLASS = {
     IS_FIREFOX: 'is-firefox',
     IS_SAFARI: 'is-safari',
     IS_IE: 'is-ie',
     IS_EDGE: 'is-edge',
     IS_CHROME: 'is-chrome',
     IS_EDGE_CHROMIUM: 'is-edge-chromium',
     IS_IOS_SAFARI: 'is-ios-safari',
};

export const CE_OF_COMPLETION_VIEWS = {
     all: 'All CEs',
     own: 'CEs I’ve Earned',
     dont_own: 'CE’s I Have Not Earned',
};

export const MY_CERTIFICATES_OF_COMPLETION_VIEWS = {
     all: 'All Certificates',
     own: 'Certificates I’ve Earned',
     dont_own: 'Certificates I Have Not Earned',
};

export const ORDER_MODE = {
     CREDIT: 'credit',
     PAY_BY_CHECK: 'pay-by-check',
     SOW: 'sow',
};

export const ORDER_CATEGORY = {
     GENERAL: 'general',
     SOW: 'sow',
};

export const PRODUCT_EVENT_CATEGORY = {
     GENERAL: 'general',
     SOW: 'sow',
};

export const SOW_REPORT_ROW_TYPES = {
     PRODUCT: 'Product',
     EVENT_DETAILS: 'Event Detail',
};

export const TRAINING_GROUP_ERROR = {
     REQUIRED: 'Group Name is required.',
     DUPLICATE: 'Group Name cannot be the same as another group.',
};

export const USER_EMAIL_ERROR = {
     REQUIRED_EMAIL: 'Email is required',
     LIMIT_EMAIL: 'Email limit is 255 characters',
     INVALID_EMAIL: 'Email is invalid',
     DUPLICATE_EMAIL: 'Email is duplicated',
     EXISTED_EMAIL: 'Email has existed',
};

export const ShippingStatusOrder = {
     NOT_AVAILABLE: 'NOT_AVAILABLE',
     NOT_SHIPPED: 'NOT_SHIPPED',
     SHIPPED: 'SHIPPED',
};

export const PAYMENT_STATUS_ORDER = {
     PAID: 'Paid',
     COMPLETED: 'Completed',
     AWAITING_PAYMENT: 'AwaitingPayment',
     CANCELED: 'Canceled',
};

export const DEFAULT_SHIPPING_STATUS = {
     NOT_SHIPPED: 'Not Shipped',
     SHIPPED: 'Shipped',
};

export const DEFAULT_SORT_BY = {
     SELF_ID: 'selfId',
     CREATED_AT: 'createdAt',
     UPDATE_AT: 'updatedAt',
     START_AT: 'startAt',
};

export const SORTING_TYPE = {
     ASC: 'asc',
     DESC: 'desc',
     ASC_NULL_FIRST: 'ASC NULLS FIRST',
     ASC_NULL_LAST: 'ASC NULLS LAST',
     DESC_NULL_FIRST: 'DESC NULLS FIRST',
     DESC_NULL_LAST: 'DESC NULLS LAST',
};

export const PREREQUISITE_CRITERIA = {
     PRODUCT: 'product',
     CERTIFICATION_LEVEL: 'certificationLevel',
};

export const SELLING_GROUP_TRAINING_LEVEL = {
     FOUNDATIONAL: 'foundational',
     ADVANCED_CAMS_CERTIFIED: 'advanced_cams-certified',
     ADVANCED_CAMS_4_TEENS: 'advanced_cams-4teens',
     ADVANCED_OTHER: 'advanced_other',
};

export const SELLING_GROUP_TRAINING_LEVEL_LABEL = {
     foundational: 'Foundational',
     'advanced_cams-certified': 'CAMS Certified',
     'advanced_cams-4teens': 'CAMS-4Teens',
     advanced_other: 'Other',
};

export const SELLING_GROUP_PACKAGE_TRAINING_LEVEL_LABEL = {
     foundational: 'Foundational',
     'advanced_cams-certified': 'Advanced',
     'advanced_cams-4teens': 'Advanced',
     advanced_other: 'Advanced',
};

export const SELLING_GROUP_TRAINING_METHOD_LABEL = {
     book: 'Book',
     'ce-credits': 'CE Credits',
     digital: 'Digital',
     'in-person': 'In-Person',
     'live-training': 'Live Training',
     live: 'Live',
     'on-demand': 'On-demand',
     'online-course': 'Online Course',
     online: 'Online',
     teams: 'Teams',

     package: 'Package',
};

export const DEFAULT_PAGINATION = {
     PAGE: 1,
     PAGE_SIZE: 20,
     ALL: 'all',
};

export const PER_PAGE_OPTIONS = [
     { id: '5', name: 5 },
     { id: '10', name: 10 },
     { id: '20', name: 20 },
     { id: '50', name: 50 },
];

export const DEFAULT_PAGINATION_INIT = {
     page: DEFAULT_PAGINATION.PAGE,
     pageSize: DEFAULT_PAGINATION.PAGE_SIZE,
     sortBy: DEFAULT_SORT_BY.CREATED_AT,
     sortType: SORTING_TYPE.DESC,
     filter: {},
};

export const DEFAULT_PAGINATION_SEAT_TABLE_INIT = {
     page: DEFAULT_PAGINATION.PAGE,
     pageSize: DEFAULT_PAGINATION.PAGE_SIZE,
     sortBy: 'reservedAt',
     sortType: SORTING_TYPE.DESC,
     filter: {},
};

export const INITIAL_STATE_PAGINATION = {
     rows: [],
     count: 0,
};

export const MAXIMUM_ACCESS_LINK = 4;

export const MAXIMUM_ZIPCODE_LENGTH = 5;

export const NOTIFICATION_PAGE_SIZE = 8;
